// Regular-staff-facing "Lab Orders" — reachable by any logged-in staff
// user (the normal `token` session, NOT admin auth), server-side scoped
// to that staff member's own lab (see backend's staff_list_lab_orders).
// Thin wrapper around the shared LabOrdersView.
import React from "react";
import LabOrdersView from "./LabOrdersView";

export default function StaffLabOrders() {
  return <LabOrdersView isAdmin={false} />;
}
